module.exports = __webpack_public_path__ + "static/media/trip_analysis.252024f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trip_analysis.png
// module id = 2139
// module chunks = 0